/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/import-syncs/all" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { integrationsDirectCdiImportSyncsAll } from "./constants";
import type { GetCdiImportSyncsAllResults } from "./types";

export const getCdiImportSyncsAll = reactQueryFetcherAdapter(
  integrationsDirectCdiImportSyncsAll,
  (signal: AbortSignal, appGroupId: string): Promise<GetCdiImportSyncsAllResults> => {
    return fetch("/integrations/direct/cdi/import-syncs/all", "GET", { app_group_id: appGroupId }, { signal });
  }
);
